import { motion } from "framer-motion";
import { Shield, Users, Lock, Server } from "lucide-react";

const securityFeatures = [
  {
    icon: Users,
    title: "Cada iglesia en su propio espacio.",
    desc: "Lo tuyo es tuyo, y nada se mezcla con otras congregaciones.",
  },
  {
    icon: Shield,
    title: "Tú decides quién ve qué.",
    desc: "El pastor tiene su acceso, el tesorero el suyo, el coordinador el suyo.",
  },
  {
    icon: Server,
    title: "Copia de seguridad diaria.",
    desc: "Si algo sale mal, nada se pierde.",
  },
  {
    icon: Lock,
    title: "Acceso solo desde dispositivos autorizados.",
    desc: "Tu cuenta es tuya.",
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.07 } },
};

const item = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.75 } },
};

export default function SecuritySection() {
  return (
    <section
      id="security"
      data-testid="security-section"
      className="relative py-20 md:py-32"
    >
      <div className="mx-4 md:mx-8 rounded-[2.5rem] overflow-hidden"
        style={{
          background: "linear-gradient(165deg, #3D3275 0%, #2E2458 55%, #1A1135 100%)",
        }}
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/50 to-transparent"
        />
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 md:px-12 md:py-28">
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.75 }}
            className="text-center max-w-3xl mx-auto mb-16"
          >
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold mb-4">
              Tu gente, protegida
            </p>
            <h2
              data-testid="security-title"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight"
            >
              Datos de la congregación, protegidos
            </h2>
            <p className="mt-5 text-xl text-ink-4 leading-relaxed">
              La información de tu gente está a salvo, y solo la ve quien tú decides. Sin complicaciones técnicas.
            </p>
          </motion.div>

          <motion.div
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5"
          >
            {securityFeatures.map((feat, i) => (
              <motion.div
                key={feat.title}
                variants={item}
                className="rounded-2xl border border-violet-medio/20 bg-violet-fuerte/30 backdrop-blur-sm p-7 md:p-8 transition-all duration-300 hover:bg-violet-fuerte/50 hover:-translate-y-1"
                data-testid={`security-card-${i}`}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold mb-5">
                  <feat.icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-xl font-bold text-white mb-3 tracking-tight">
                  {feat.title}
                </h3>
                <p className="text-lg text-ink-4 leading-relaxed">
                  {feat.desc}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
